import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert/alert.component';
import { AlertService } from './alert.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertModule as AlertMod } from 'ngx-bootstrap/alert';

@NgModule({
	declarations: [AlertComponent],
	exports: [AlertComponent],
	imports: [CommonModule, NgbModule, AlertMod.forRoot()],
	providers: [AlertService]
})
export class AlertModule {}
